import { TAdvisorFields, TAdvisorProps } from '../types/advisor.types';

export class AdvisorModel {
  private readonly fields?: TAdvisorFields;
  constructor(props: TAdvisorProps) {
    this.fields = props?.fields || null;
  }

  get featuredImage() {
    return this.fields?.image;
  }

  get proceedButtonText() {
    return this.fields?.proceedButtonText;
  }

  get scriptUrl() {
    return this.fields?.scriptUrl;
  }
}
